<template>
  <main
    :class="{
      'flex min-h-screen items-center justify-center bg-www-color-neutral-off-white p-14': true,
    }"
  >
    <div
      :class="{
        'w-full max-w-[800px] rounded-md bg-www-color-white p-12 shadow-flip-card': true,
      }"
    >
      <h1
        :class="{
          'mb-8 text-2xl text-[1.62rem] font-semibold': true,
        }"
      >
        {{ data?.name }}
      </h1>
      <div
        v-if="entries"
        :class="{
          'space-y-8': true,
        }"
      >
        <div
          v-for="entry in entries"
          :id="entry.reference?.releaseVersion"
          :key="entry.reference?._id"
          :class="{
            'border-t-2 border-www-color-neutral-off-white py-4': true,
          }"
        >
          <h2
            :class="{
              'mb-3 mt-4 text-[1.62rem] font-semibold leading-snug': true,
            }"
          >
            {{ entry.reference?.releaseVersion
            }}<span
              :class="{
                'text-base font-normal': true,
              }"
            >
              - released {{ entry.reference?.releaseDate }}</span
            >
          </h2>
          <a
            v-if="entry.reference?.forumPostLink && entry.reference.forumPostLink.length > 0"
            :href="entry.reference.forumPostLink"
            target="_blank"
            rel="noopener noreferrer"
            :class="{
              'text-www-color-accent-blue hover:underline': true,
            }"
          >
            View forum post
          </a>
          <ul
            :class="{
              'mt-4 list-disc space-y-2': true,
            }"
          >
            <li
              v-for="(item, index) in entry.reference?.content"
              :key="index"
              :class="{
                'text-gray-700': true,
              }"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>

      <div v-else>
        <p
          :class="{
            'text-gray-500 text-center': true,
          }"
        >
          No changelog entries available.
        </p>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { queryChangelog } from '~/queries/pages/PageChangelog.query';
import type { QueryChangelogResult } from '~/sanity/types';

const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQueryNonNull<QueryChangelogResult>(queryChangelog, {
  currentPathname,
});

const entries = data.value?.entries || [];
</script>
